/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService
 */

export const LessonProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.LessonProgressResponse';
export const PlaylistProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.PlaylistProgressResponse';
export const ShortProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.ShortProgressResponse';
export const TrackProgressResponseTypename = 'com.hubspot.userprogress.bff.rpc.models.TrackProgressResponse';
export let ComHubspotUserprogressBffRpcModelsAbstractUserProgressError;
(function (_ComHubspotUserprogressBffRpcModelsAbstractUserProgressError) {})(ComHubspotUserprogressBffRpcModelsAbstractUserProgressError || (ComHubspotUserprogressBffRpcModelsAbstractUserProgressError = {}));
export let ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError;
(function (_ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError) {})(ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError || (ComHubspotUserprogressBffRpcModelsUserprogressAbstractUserProgressReadError = {}));
export const getUserProgressRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserProgress',
  auth: 'app',
  fingerprint: 'EyWYBYoafJiaUsiRSyJ8oK4AvDvBA3a6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserLessonProgressRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserLessonProgress',
  auth: 'app',
  fingerprint: '5s9xr8DEgluEsVhuWrGNMAxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getUserTrackProgressRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getUserTrackProgress',
  auth: 'app',
  fingerprint: 'HW3JR86f2stnSvuDm1uDtQxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllUserProgressByUserIdRpc = {
  serviceName: 'com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService',
  rpcName: 'getAllUserProgressByUserId',
  auth: 'app',
  fingerprint: 'YBIXzl6izPd0pv7BTTvW7QxMK10-h47i',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};